/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 11:17 AM
 */

import { APP_PROP_CHANGE } from '../actions';

const INITIAL_STATE = {
	zipCode    : '',
	hasService : null,
};

export default function ( state = INITIAL_STATE, action ) {
	switch ( action.type ) {
		case APP_PROP_CHANGE:
			return {
				...state,
				...action.payload
			};
		default:
			return state;
	}
}
